export enum EEstimationType {
  DIRECT = "DIRECT",
  SIMPLIFIED = "SIMPLIFIED",
  ADVANCED = "ADVANCED",
  WATER_HEATER = "WATER_HEATER",
}
